var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filters-buttons-container"},_vm._l((_vm.filters),function(filter,index){return _c('custom-button',{key:'filter' + index,attrs:{"label":filter.label,"icon":filter.icon,"icon-size":16,"icon-color":_vm.activeFilter === index ? '#ffffff' : filter.color,"height":'60px',"width":'160px',"label-color":_vm.activeFilter === index ? '#ffffff' : filter.color,"button-color":_vm.activeFilter === index ? filter.color : '#ffffff',"button-styling":{
      'border-radius': '8px',
      'box-shadow': '0px 3.25px 3.25px 0px rgba(0, 0, 0, 0.25)',
      'border': '1px solid',
      'border-color': filter.color,
      'font-size': '15px',
      'line-height': '15px',
    }},on:{"buttonClick":function($event){return _vm.selectFilter(index)}}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70f19942","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/_Molecules/FilterButtons.vue
// module id = null
// module chunks = 